import { Box } from '@mui/material';
import { useIntl } from 'react-intl';

import type { OfferMemberProgress } from '@ocx/data-offers';
// eslint-disable-next-line @nx/enforce-module-boundaries
import { Typography, SizingMultiplier } from '@ocx/ui';

import { LinearProgress } from './linear-progress.component';
import { OfferProgressFormatVariant } from '../../offer-card/offer-card.types';
import { formatOfferProgressValue } from '../offer-progress-over-time.utils';

export const PROGRESS_BAR_TEST_ID = 'offer_membership_progress_bar';

type BarProps = OfferMemberProgress & { variant: OfferProgressFormatVariant };

export const Bar = ({ required, achieved, variant }: BarProps) => {
  const { formatNumber } = useIntl();

  return (
    <Box display="flex" flexGrow={1} alignItems="center" mr={SizingMultiplier.xs} data-testid={PROGRESS_BAR_TEST_ID}>
      <LinearProgress value={required > 0 ? (achieved / required) * 100 : 0} />
      <Typography variant="subtitle2" component="span" ml={SizingMultiplier.sm}>
        {formatOfferProgressValue({ value: achieved, variant, formatNumber })}
      </Typography>
      <Typography variant="subtitle2" component="span" color="text.disabled">
        /{formatOfferProgressValue({ value: required, variant, formatNumber })}
      </Typography>
    </Box>
  );
};
